import { createAsyncThunk } from "@reduxjs/toolkit";
import { openErrorMessage, openSuccessMessage } from "../slices/toastSlice";
import {
  getSubscriptionPlans,
  getMySubscription,
  createSubscriptionCheckout,
  cancelSubscription,
  resumeSubscription,
  changePlan,
  getBillingPortal,
  validateCoupon,
} from "../../api/subscriptions.api";

export const fetchPlans = createAsyncThunk(
  "subscription/fetchPlans",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await getSubscriptionPlans();
      return res.data.plans;
    } catch (err) {
      dispatch(openErrorMessage(err?.response?.data?.message || err.message));
      return rejectWithValue(err.message);
    }
  }
);

export const fetchMySubscription = createAsyncThunk(
  "subscription/fetchMySubscription",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getMySubscription();
      return res.data.subscription;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const startCheckout = createAsyncThunk(
  "subscription/startCheckout",
  async ({ planId, couponCode } = {}, { rejectWithValue, dispatch }) => {
    try {
      const res = await createSubscriptionCheckout(planId, couponCode);
      const url = res.data.session?.url;
      if (url) window.location.href = url;
      return url;
    } catch (err) {
      dispatch(openErrorMessage(err?.response?.data?.message || err.message));
      return rejectWithValue(err.message);
    }
  }
);

export const applyCoupon = createAsyncThunk(
  "subscription/applyCoupon",
  async ({ couponCode, subscriptionPlanId }, { rejectWithValue, dispatch }) => {
    try {
      const res = await validateCoupon(couponCode, subscriptionPlanId);
      return res.data;
    } catch (err) {
      dispatch(openErrorMessage(err?.response?.data?.message || err.message));
      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  }
);

export const cancelMySubscription = createAsyncThunk(
  "subscription/cancel",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await cancelSubscription();
      dispatch(openSuccessMessage(res.data.message));
      return true;
    } catch (err) {
      dispatch(openErrorMessage(err?.response?.data?.message || err.message));
      return rejectWithValue(err.message);
    }
  }
);

export const resumeMySubscription = createAsyncThunk(
  "subscription/resume",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await resumeSubscription();
      dispatch(openSuccessMessage(res.data.message));
      return true;
    } catch (err) {
      dispatch(openErrorMessage(err?.response?.data?.message || err.message));
      return rejectWithValue(err.message);
    }
  }
);

export const changeMyPlan = createAsyncThunk(
  "subscription/changePlan",
  async (planId, { rejectWithValue, dispatch }) => {
    try {
      const res = await changePlan(planId);
      dispatch(openSuccessMessage(res.data.message));
      return true;
    } catch (err) {
      dispatch(openErrorMessage(err?.response?.data?.message || err.message));
      return rejectWithValue(err.message);
    }
  }
);

export const openBillingPortal = createAsyncThunk(
  "subscription/billingPortal",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await getBillingPortal();
      if (res.data.url) window.location.href = res.data.url;
    } catch (err) {
      dispatch(openErrorMessage(err?.response?.data?.message || err.message));
      return rejectWithValue(err.message);
    }
  }
);